import BannerService from './BannerService';
export default BannerService;
